var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArwActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 72,
    viewBox: "0 0 65 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1,
    clipPath: "url(#clip0_7201_48491)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 77.16V83.06H61.44V77.16H39.55V47C45.33 45.36 49.46 42.48 52.35 38.18C56.04 32.7 56.18 25.65 52.74 19.31C51.36 16.78 48.18 10.96 45.83 6.66L64.22 5.95V5.34L35.44 0L37.84 4.37C37.84 4.37 45.25 17.89 47.55 22.13C49.92 26.5 49.89 31.26 47.45 34.88C43.8 40.31 36.95 42.73 25.26 42.73H21.64L39.74 31.57V24.63L0.83 48.64H25.26C28.31 48.64 31.1 48.48 33.64 48.16V77.16H0Z",
    fill: "#6AD67D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7201_48491"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.22,
    height: 83.06,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArwActive);
export default __webpack_public_path__ + "static/media/arw-active.474c454be81a3687d42b1e65c5afb3de.svg";
export { ForwardRef as ReactComponent };